export enum FeatureAnalysisRowLevel {
  Section = "section",
  SubSection = "subSection",
  Feature = "feature",
}
